// extracted by mini-css-extract-plugin
export default {"badge":"popular-badge_badge__WMWt3"};